import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClipboard24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconClipboard24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 2.5A1.75 1.75 0 0 0 7.268 4H7a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3h-.268A1.75 1.75 0 0 0 15 2.5zm-2 3h.268C7.389 6.348 8.118 7 9 7h6a1.75 1.75 0 0 0 1.732-1.5H17A1.5 1.5 0 0 1 18.5 7v11a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 18V7A1.5 1.5 0 0 1 7 5.5m1.75-1.25A.25.25 0 0 1 9 4h6a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25H9a.25.25 0 0 1-.25-.25zm3.25 5a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0V14h-2.5a.75.75 0 0 1 0-1.5h2.5V10a.75.75 0 0 1 .75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClipboard24);
